<template>
  <EditarBase
    :itemAtual="itemAtual"
    :recursoInicial="recursoInicial"
    nomeSingular="Pais"
    nomePlural="Paises"
    @recurso="recurso = $event"
    @submitSuccess="emitSubmitSuccess"
    @submitError="emitSubmitError"
    @closeModalEdit="closeModalEdit"
  >
    <v-col cols="12">
      <v-row>
        <v-col cols="12" md="6">
          <span class="opacity-5 text-dark">
            {{ $t("Nome") }}
          </span>
          <v-text-field
            v-model="recurso.nome"
            :label="$t('Nome')"
            name="nome"
            class="
              input-style
              font-size-input
              text-light-input
              placeholder-light
              input-icon
            "
            dense
            flat
            filled
            solo
          >
          </v-text-field>
        </v-col>
        <v-col cols="12" md="4">
          <span class="opacity-5 text-dark">
            {{ $t("Sigla") }}
          </span>
          <v-text-field
            v-model="recurso.sigla"
            :label="$t('Sigla')"
            name="sigla"
            class="
              input-style
              font-size-input
              text-light-input
              placeholder-light
              input-icon
            "
            dense
            flat
            filled
            solo
          >
          </v-text-field>
        </v-col>
        <v-col cols="12" md="2">
          <span class="opacity-5 text-dark">
            {{ $t("Moeda") }}
          </span>
          <v-text-field
            v-model="recurso.moeda"
            :label="$t('Moeda')"
            name="moeda"
            class="
              input-style
              font-size-input
              text-light-input
              placeholder-light
              input-icon
            "
            dense
            flat
            filled
            solo
          >
          </v-text-field>
        </v-col>
      </v-row>
    </v-col>
    <CamposPortaisOportunidades local="Pais" :value="recurso.portaisOportunidades" @input="$set(recurso, 'portaisOportunidades', $event)" />
  </EditarBase>
</template>

<script>
import CamposPortaisOportunidades from "@/components/locais/portais/CamposPortaisOportunidades";
import EditarBase from "@/components/base/Crud/EditarBase";
import DataService from "@/services/locais/PaisDataService";

export default {
  props: {
    itemAtual: { type: Object, required: false, default: null },
    recursoInicial: { type: Object, required: false, default: null },
  },
  name: "EditarPais",
  components: { EditarBase, CamposPortaisOportunidades },
  data() {
    return {
      submited: false,
      DataService: DataService,

      recurso: {
        nome: "",
        sigla: "",
        moeda: "",
      },

      errors: [],
    };
  },
  methods: {
    emitSubmitSuccess(recursoAtualizado = this.recurso) {
      this.$emit("submitSuccess", recursoAtualizado);
    },
    emitSubmitError() {
      this.$emit("submitError");
    },
    closeModalEdit() {
      this.$emit("closeModalEdit");
    },
  },
};
</script>

<style scoped></style>
